import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldEditorUnsavedChangesComponent } from './field-editor-unsaved-changes.component';
import {DxButtonModule, DxPopoverModule, DxPopupModule, DxSpeedDialActionModule, DxToolbarModule} from 'devextreme-angular';



@NgModule({
  declarations: [FieldEditorUnsavedChangesComponent],
  imports: [
    CommonModule,
    DxSpeedDialActionModule,
    DxButtonModule,
    DxToolbarModule,
    DxPopupModule,
    DxPopoverModule
  ],
  exports: [FieldEditorUnsavedChangesComponent]
})
export class FieldEditorUnsavedChangesModule { }
